// Work Order status columns (Kanban)
export const WO_STATUS_COLUMNS = [
  { id: 'received', label: 'Recibido', color: '#6b7280' },
  { id: 'diagnosis', label: 'Diagnóstico', color: '#8b5cf6' },
  { id: 'in_progress', label: 'En Progreso', color: '#3b82f6' },
  { id: 'ready', label: 'Listo', color: '#22c55e' },
  { id: 'delivered', label: 'Entregado', color: '#64748b' },
];

// Work Order status labels
export const WO_STATUS_LABELS = {
  received: 'Recibido',
  diagnosis: 'En Diagnóstico',
  in_progress: 'En Progreso',
  ready: 'Listo',
  delivered: 'Entregado',
};

// Work Order priority labels with colors
export const WO_PRIORITY_LABELS = {
  low: { label: 'Baja', color: '#6b7280' },
  normal: { label: 'Normal', color: '#3b82f6' },
  high: { label: 'Alta', color: '#f59e0b' },
  urgent: { label: 'Urgente', color: '#ef4444' },
};

// Inspection item categories
export const INSPECTION_CATEGORIES = [
  { value: 'brakes', label: 'Frenos' },
  { value: 'engine', label: 'Motor' },
  { value: 'suspension', label: 'Suspensión' },
  { value: 'steering', label: 'Dirección' },
  { value: 'electrical', label: 'Eléctrico' },
  { value: 'transmission', label: 'Transmisión' },
  { value: 'tires', label: 'Neumáticos' },
  { value: 'fluids', label: 'Fluidos' },
  { value: 'bodywork', label: 'Carrocería' },
  { value: 'lights', label: 'Luces' },
  { value: 'ac_heating', label: 'A/C y Calefacción' },
  { value: 'exhaust', label: 'Escape' },
  { value: 'interior', label: 'Interior' },
  { value: 'safety', label: 'Seguridad' },
  { value: 'other', label: 'Otro' },
];

// Inspection status colors
export const INSPECTION_STATUS_COLORS = {
  pending: '#9ca3af',
  good: '#22c55e',
  attention: '#f59e0b',
  critical: '#ef4444',
};

// Get inspection category label from value
export const getInspectionCategoryLabel = (value) => {
  const cat = INSPECTION_CATEGORIES.find(c => c.value === value);
  return cat ? cat.label : value;
};

// Route paths
export const ROUTES = {
  HOME: '/',
  LANDING: '/inicio',
  ADQUIRIR: '/adquirir',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  DASHBOARD: '/dashboard',
  CUSTOMERS: '/customers',
  VEHICLES: '/vehicles',
  WORKORDERS: '/workorders',
  USERS: '/users',
  SELECT_SHOP: '/select-shop',
  SHOPS: '/shops',
  INSPECTIONS: '/inspections',
};

// Local storage keys
export const STORAGE_KEYS = {
  AUTH: 'auth-storage',
};

// API endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    ME: '/auth/me',
  },
  USERS: {
    ME: '/users/me',
    PASSWORD: '/users/me/password',
  },
  HEALTH: '/health',
};
